import React from "react"
import PropTypes from "prop-types"
import "./index.less"
import { validate } from "../../../../../../utils/functions"
import {
  isAmbassadorActive,
  isModuleBySlug,
} from "../../../../../../utils/storage"
import {
  BENCHMARK,
  HISTORICAL_ANALYSIS,
  TYPE_SURVEY,
} from "../../../../../../utils/constants"
import { get } from "lodash"
import { loadTexts, sanitize } from "../../../../../../utils/i18n"

export function CustomTooltip(props) {
  const intlTooltip = loadTexts("reports_general_view").reportAmbassador
    .engagementMeasurement.widgetResultByDimensionEngagement.tooltip
  const renderBenchmark = (payload, measureGeneral) => {
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()) {
      return null
    }
    if (!isBenchmark) {
      return null
    }

    if (
      get(
        props.measureGeneral,
        "id_survey_type",
        TYPE_SURVEY.climate.idSurveyType
      ) !== TYPE_SURVEY.climate.idSurveyType
    ) {
      return null
    }

    if (payload.id_parent !== 0 && payload.id_parent !== undefined) {
      return null
    }
    if (!validate.exist(payload.benchmark_value)) {
      return (
        <div className="tooltipBarContainer-bottom-benchmark">
          <div className="tooltipBarContainer-bottom-benchmark-title">
            {intlTooltip.benchmark}
          </div>
          <div className="tooltipBarContainer-bottom-benchmark-content">
            <div className="tooltipBarContainer-bottom-benchmark-content-value">
              -
            </div>
            <div className="tooltipBarContainer-bottom-benchmark-content-message">
              {sanitize(intlTooltip.noBenchmarkForDimension)}
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className="tooltipBarContainer-bottom-benchmark">
        <div className="tooltipBarContainer-bottom-benchmark-title">
          {intlTooltip.benchmark}
        </div>
        <div className="tooltipBarContainer-bottom-benchmark-value">
          {`${payload.benchmark_value}%`}
        </div>
      </div>
    )
  }

  const renderPrevious = (payload) => {
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    if (
      !isHistoricalAnalysis ||
      !validate.exist(payload.prev_value) ||
      payload.prev_value === ""
    ) {
      return null
    }
    return (
      <div className="tooltipBarContainer-bottom-previous">
        <div className="tooltipBarContainer-bottom-previous-title">
          {intlTooltip.previousMeasure}
        </div>
        <div className="tooltipBarContainer-bottom-previous-value">
          {payload.prev_value?.toString().includes('%') 
            ? payload.prev_value 
            : `${payload.prev_value}%`}
        </div>
      </div>
    )
  }

  const hideBottomTooltip = () => {
    let isPrev = true
    let isBench = true

    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    if (
      !isHistoricalAnalysis ||
      !validate.exist(payload.prev_value) ||
      payload.prev_value === ""
    ) {
      isPrev = false
    }
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (
      !props.measureGeneral.ambassador_benchmark_visible &&
      isAmbassadorActive()
    ) {
      isBench = false
    }
    if (!isBenchmark) {
      isBench = false
    }
    if (payload.id_parent !== 0 && payload.id_parent !== undefined) {
      isBench = false
    }
    return !(isPrev === false && isBench === false)
  }

  let payload = {}
  if (validate.exist(props.element) && props.element.active) {
    if (
      validate.exist(props.element.payload) &&
      props.element.payload.length > 0
    ) {
      payload = props.element.payload[0].payload
    }
  }

  if (payload.anonymity_check) {
    if (payload.employees < payload.anonymity_check.current_used) {
      return (
        <div className="tooltipBarContainer">
          <div className="tooltipBarContainer-top">
            Esta dimensión no cumple con el número de respuestas configurado en
            el anonimato.
          </div>
        </div>
      )
    }
  }

  return (
    <div className="tooltipBarContainer">
      <div className="tooltipBarContainer-top">
        <div className="tooltipBarContainer-top-left">
          <div className="tooltipBarContainer-top-left-title">
            {`${payload.name}`}
          </div>
          <div className="tooltipBarContainer-top-left-employees">
            <span style={{ fontWeight: 600 }}>{payload.employees}</span>
            {intlTooltip.collaboratorsFrom +
              payload.recipients +
              intlTooltip.collaborators}
          </div>
        </div>
        <div className="tooltipBarContainer-top-right">
          <div
            className="tooltipBarContainer-top-right-content"
            style={{ backgroundColor: payload.color }}>
            <span>
              {props.measureGeneral.id_survey_calculation_type === 1
                ? `${Math.round(payload.value)}%`
                : `${payload.value_visible}`}
            </span>
          </div>
        </div>
      </div>
      {hideBottomTooltip() && (
        <div className="tooltipBarContainer-bottom">
          {renderPrevious(payload)}
          {renderBenchmark(payload, props.measureGeneral)}
        </div>
      )}
    </div>
  )
}

CustomTooltip.propTypes = {
  element: PropTypes.object,
  measureGeneral: PropTypes.object,
}

export default CustomTooltip
